import { Injectable } from '@angular/core';
import { EntityState, EntityStore, EntityUIStore, StoreConfig } from '@datorama/akita';
import { createInitUI, FileUI } from './file-ui.model';
import { FileUploadInfo } from './file.model';

export interface FileState extends EntityState<FileUploadInfo> {}

export type FileUIState = EntityState<FileUI>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'chat-shared-core-file', idKey: 'fileId' })
export class FileStore extends EntityStore<FileState> {
  override ui: EntityUIStore<FileUIState>;
  constructor() {
    super({
      loading: false
    });
    this.createUIStore({}).setInitialEntityState(entity => createInitUI());
  }
}
